import React, { useEffect } from "react";
import './App.css';
import Header from './Components/Header/Header';
import Home from './Components/Home/Home';
import { useLocation } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Footer from "./Components/Footer/footer";
import Aboutus from "./Components/About/Aboutus";
import Contactus from "./Components/Contact/Contactus";
import { BiLogoSass } from "react-icons/bi";
import BlogsDetails from './Components/Blogs/BlogDetails'
import Blog from "./Components/Blogs/Blog";
import Case from "./Components/CaseResult/Case";
import Results from "./Components/CaseResult/Results";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, [pathname]);

  return null;
}

function App() {
  return (
    <Router>
      <Header />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogsDetails />} />
        <Route path="/results" element={<Case />} />
        <Route path="/results/:id" element={<Results />} />
      </Routes>
      <Footer/>
    </Router>
  );
}

export default App;
